










import { Vue, Component } from 'vue-property-decorator';
import InformePreparacionBase from './InformePreparacionBase.vue';

@Component({
  components: { InformePreparacionBase },
})
export default class InformePreparacionPantalla extends Vue {}
